import { Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { useState } from 'react';

import { eliminarProyecto } from '../../../actions/proyectos';

const EliminarProyectoModal = ({ show, onHide, idProyecto }) => {
    const dispatch = useDispatch();
    const [saving, setSaving] = useState(false);

    const onConfirm = async () => {
        if (!idProyecto) {
            onHide();
            return;
        }

        setSaving(true);
        const ok = await dispatch(eliminarProyecto(idProyecto));
        setSaving(false);

        if (ok) {
            onHide();
        }
    };

    return (
        <Modal show={show} onHide={onHide} centered backdrop="static">
            <Modal.Header closeButton>
                <Modal.Title>Eliminar proyecto</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <div className="alert alert-warning m-0">
                    ¿Estás seguro que deseas eliminar este proyecto? Esta acción no es reversible.
                </div>
            </Modal.Body>

            <Modal.Footer>
                <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={onHide}
                    disabled={saving}
                >
                    Cancelar
                </button>
                <button
                    type="button"
                    className="btn btn-danger"
                    onClick={onConfirm}
                    disabled={saving}
                >
                    Eliminar
                </button>
            </Modal.Footer>
        </Modal>
    );
};

export default EliminarProyectoModal;
